import React, {useEffect, useState} from 'react'
import * as Yup from "yup";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import Switch from "react-bootstrap-switch";
import {connect} from "react-redux";
import {useForm} from "react-hook-form";


// components
import { ButtonCancel, ButtonSubmit,} from "../../../components/buttons/buttonsActions";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {
    LB_MAX_WEIGHT, LB_MIN_MAX_HEIGHT, LB_MIN_MAX_WIDTH,
    FORM, LB_PATH, LB_IS_GALLERY, LB_IS_THUMB, LB_IS_LANG, LB_SAME_IMG_LANGS, LB_ASPECT_RATIO, LB_ORDER_CONFIG, LB_ALLOWED_FORMATS, LB_LABEL
} from "../../../components/i18n/i18n";
import { PH_CODE } from "../../../components/i18n/placeHolders";
import { FL_CODE } from "../../../components/i18n/formLabels";

// actions
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {genericActions} from "../../../redux/actions/generics/GenericActions";

// services
import {fbMediaConfigService} from "../../../jwt/_services/configuration/fbMediaConfigService";

// providers
import {mainProvider} from "../../../providers/mainProvider";
import {fbDatabaseProvider} from "../../../providers/fbDatabaseProvider";

const FbMediaConfigForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;

    const [fbDataBaseId, setFbDataBaseId] = useState(domainObject?.fbDataBase?.id || null);
    const [className, setClassName] = useState(domainObject?.className || null);
    const [settings, setSettings] = useState({
        useThumb: domainObject?.useThumb || false,
        useGallery: domainObject?.useGallery || false,
        use18n: domainObject?.use18n || false,
        use18nSameImage: domainObject?.use18nSameImage || false,
    });

    const validationSchema = Yup.object().shape({});

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            fieldCode: domainObject?.fieldCode || '',
            fbMediaLabel: domainObject?.fbMediaLabel || '',
            showOrder: domainObject?.showOrder,
            formatsAllowed: domainObject?.formatsAllowed || '',
            path: domainObject?.path || '',
            aspectRatio: domainObject?.aspectRatio || '',
            maxWeight: domainObject?.maxWeight,
            minMaxWidth: domainObject?.minMaxWidth,
            minMaxHeight: domainObject?.minMaxHeight,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            item : {
                ...data,
                fbDataBase:{ id: fbDataBaseId },
                className,
                useThumb: settings.useThumb,
                useGallery: settings.useGallery,
                useLangs: settings.useLangs,
                use18n: settings.use18n,
                use18nSameImage: settings.use18nSameImage
            }
        };

        if (!editMode)
            genericActions.save(fbMediaConfigService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(fbMediaConfigService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }


    const toggleSetting = (key) => {
        setSettings((prev) => ({
            ...prev,
            [key]: !prev[key],
            ...(key === 'useGallery' ? { useThumb: false, use18n: false, use18nSameImg: false } : {}),
            ...(key === 'use18n' ? { use18nSameImage: false } : {}),
            ...(key !== 'useGallery' ? { useGallery: false } : {}),
        }));
    };

    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}
        </CardTitle>
        <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{ 'Paquete . Clase' }</Label>
                            <SelectGeneric
                                initialValue={ className }
                                setExternalValue={ setClassName }
                                provider={ mainProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>Base de datos</Label>
                            <br/>
                            <SelectGeneric
                                isDisabled={ disableInputs }
                                initialValue={ fbDataBaseId }
                                setExternalValue={ setFbDataBaseId }
                                provider={ fbDatabaseProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_LABEL}</Label>
                            <Input
                                type="text"
                                name="fbMediaLabel"
                                placeholder={LB_LABEL}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="fieldCode"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_PATH}</Label>
                            <Input
                                type="text"
                                name="path"
                                placeholder="path/sub-path/"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>  
                    <Col>
                        <FormGroup>
                            <Label>{LB_ASPECT_RATIO}</Label>
                            <br/>
                            <Input
                                type="text"
                                name="aspectRatio"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_ALLOWED_FORMATS}</Label>
                            <br/>
                            <Input
                                type="text"
                                name="formatsAllowed"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_MAX_WEIGHT}</Label>
                            <Input
                                type="number"
                                name="maxWeight"
                                min="0"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_MIN_MAX_WIDTH}</Label>
                            <Input
                                type="number"
                                name="minMaxWidth"
                                min="0"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_MIN_MAX_HEIGHT}</Label>
                            <Input
                                type="number"
                                name="minMaxHeight"
                                min="0"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_ORDER_CONFIG}</Label>
                            <br/>
                            <Input
                                type="number"
                                name="showOrder"
                                min="0"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_IS_THUMB}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={settings.useThumb}
                                onChange={() => toggleSetting('useThumb')}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_IS_GALLERY}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={settings.useGallery}
                                onChange={() => toggleSetting('useGallery')}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_IS_LANG}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={settings.use18n}
                                onChange={() => toggleSetting('use18n')}
                            />  
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_SAME_IMG_LANGS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={settings.use18nSameImage}
                                onChange={() => toggleSetting('use18nSameImage')}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <CardBody className="border-top">
                    <div className="float-right">
                        <ButtonSubmit/>
                        <ButtonCancel onClick={closeForm}/>
                    </div>
                </CardBody>
            </Form>
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(FbMediaConfigForm)